module.exports = __webpack_public_path__ + "static/media/overview-large.fa25a9ef.png";